import React, { useEffect, useState, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './InvestorRelationsDocs.css';

import cdslPdf from '../assets/investorRelationsAssets/CDSL And NSDL Agreement/CDSL.pdf';
import nsdlPdf from '../assets/investorRelationsAssets/CDSL And NSDL Agreement/NSDL Agreement.pdf';

import brAcNrcPdf from '../assets/investorRelationsAssets/Comitties Resolution/BR FOR AC NRC.pdf';
import csrCommitteePdf from '../assets/investorRelationsAssets/Comitties Resolution/CSR COMMITTEE.pdf';
import srcCommitteePdf from '../assets/investorRelationsAssets/Comitties Resolution/SRC COMMITTEE.pdf';

import upsiPdf from '../assets/investorRelationsAssets/Policies/1. Code of Practice and procedure for UPSI.pdf';
import whistleBlowerPdf from '../assets/investorRelationsAssets/Policies/2. Whistle Blower policy.pdf';
import rptMaterialityPdf from '../assets/investorRelationsAssets/Policies/3. Policy_on_Materiality_of_Related_Party_Transactions.pdf';
import preservationPdf from '../assets/investorRelationsAssets/Policies/4. Policy on Preservation and Archival of Documents.pdf';
import poshPdf from '../assets/investorRelationsAssets/Policies/5. Policy_on_prevention_of_Sexual_Harrasement_at_workplace_POSH.pdf';
import insiderTradingPdf from '../assets/investorRelationsAssets/Policies/6. Prohibition of Insider Trading Policy.pdf';
import materialityDeterminationPdf from '../assets/investorRelationsAssets/Policies/7. Policy_on_Determination_of_Materiality.pdf';
import codeOfConductPdf from '../assets/investorRelationsAssets/Policies/8. Code of Conduct for Directors and Senior Management.pdf';
import familiarizationPdf from '../assets/investorRelationsAssets/Policies/9. Familiarization_Programme_of_ID.pdf';
import nominationRemunerationPdf from '../assets/investorRelationsAssets/Policies/10. Nomination_and_Remuneration_Policy.pdf';
import idAppointmentPdf from '../assets/investorRelationsAssets/Policies/11. Terms_conditions_of_Appointment_of_Independent_Directors.pdf';
import nedPaymentPdf from '../assets/investorRelationsAssets/Policies/12. Criteria_or_Policy_for_making_payments_to_NED.pdf';
import materialityPolicyPdf from '../assets/investorRelationsAssets/Policies/13. Materiality Policy.pdf';

import dpMaharajaPolyfabPdf from '../assets/ipoDocs/DP MAHARAJA POLYFAB LIMITED12.09.2026.pdf';
import draftAbridgedProspectusPdf from '../assets/ipoDocs/Abridged Draft Prospectus 12.09.26-1.pdf';

import odishaBhaskarAd from '../assets/advertisment/Odisha Bhaskar 16.9.26-1.jpg';
import delhiAd from '../assets/advertisment/Delhi-september-15-2026-page-5.png';
import mumbaiAd from '../assets/advertisment/Mumbai-september-16-2026-page-29.png';

const TABS = [
  { key: 'agreements', label: 'Contract Agreements' },
  { key: 'committees', label: 'Committees Resolution' },
  { key: 'policies', label: 'Policies' },
  { key: 'ipo', label: 'Initial Public Offering' },
  { key: 'advertisement', label: 'Advertisement' }
];

const DOCUMENTS = {
  agreements: [
    { name: 'CDSL Agreement', file: cdslPdf, fileName: 'CDSL.pdf' },
    { name: 'NSDL Agreement', file: nsdlPdf, fileName: 'NSDL-Agreement.pdf' }
  ],
  committees: [
    { name: 'Board Resolution for AC & NRC', file: brAcNrcPdf, fileName: 'BR-FOR-AC-NRC.pdf' },
    { name: 'CSR Committee', file: csrCommitteePdf, fileName: 'CSR-COMMITTEE.pdf' },
    { name: 'SRC Committee', file: srcCommitteePdf, fileName: 'SRC-COMMITTEE.pdf' }
  ],
  policies: [
    { name: 'Code of Practice and Procedure for UPSI', file: upsiPdf, fileName: 'Code-of-Practice-UPSI.pdf' },
    { name: 'Whistle Blower Policy', file: whistleBlowerPdf, fileName: 'Whistle-Blower-Policy.pdf' },
    { name: 'Policy on Materiality of Related Party Transactions', file: rptMaterialityPdf, fileName: 'Policy-on-Materiality-of-RPT.pdf' },
    { name: 'Policy on Preservation and Archival of Documents', file: preservationPdf, fileName: 'Policy-on-Preservation-and-Archival.pdf' },
    { name: 'Policy on Prevention of Sexual Harassment at Workplace (POSH)', file: poshPdf, fileName: 'POSH-Policy.pdf' },
    { name: 'Prohibition of Insider Trading Policy', file: insiderTradingPdf, fileName: 'Insider-Trading-Policy.pdf' },
    { name: 'Policy on Determination of Materiality', file: materialityDeterminationPdf, fileName: 'Policy-on-Determination-of-Materiality.pdf' },
    { name: 'Code of Conduct for Directors and Senior Management', file: codeOfConductPdf, fileName: 'Code-of-Conduct.pdf' },
    { name: 'Familiarization Programme of Independent Directors', file: familiarizationPdf, fileName: 'Familiarization-Programme-ID.pdf' },
    { name: 'Nomination and Remuneration Policy', file: nominationRemunerationPdf, fileName: 'Nomination-and-Remuneration-Policy.pdf' },
    { name: 'Terms & Conditions of Appointment of Independent Directors', file: idAppointmentPdf, fileName: 'Terms-Appointment-ID.pdf' },
    { name: 'Criteria / Policy for Making Payments to NED', file: nedPaymentPdf, fileName: 'Policy-Payments-to-NED.pdf' },
    { name: 'Materiality Policy', file: materialityPolicyPdf, fileName: 'Materiality-Policy.pdf' }
  ],
  ipo: [
    { name: 'DP Maharaja Polyfab Limited', file: dpMaharajaPolyfabPdf, fileName: 'DP-Maharaja-Polyfab-Limited.pdf' },
    { name: 'Draft Abridged Prospectus', file: draftAbridgedProspectusPdf, fileName: 'Draft-Abridged-Prospectus.pdf' }
  ],
  advertisement: [
    { name: 'Odisha Bhaskar - 16.09.2026', file: odishaBhaskarAd, fileName: 'Odisha-Bhaskar-16-09-2026.jpg', type: 'image' },
    { name: 'Delhi Advertisement - 15.09.2026', file: delhiAd, fileName: 'Delhi-Advertisement.png', type: 'image' },
    { name: 'Mumbai Advertisement - 16.09.2026', file: mumbaiAd, fileName: 'Mumbai-Advertisement.png', type: 'image' }
  ]
};

const VALID_KEYS = TABS.map(t => t.key);

const InvestorRelationsDocs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const initialTab = VALID_KEYS.includes(location.hash.slice(1)) ? location.hash.slice(1) : 'agreements';
  const [activeTab, setActiveTab] = useState(initialTab);
  const [previewDoc, setPreviewDoc] = useState(null);

  useEffect(() => {
    const key = location.hash.slice(1);
    if (VALID_KEYS.includes(key) && key !== activeTab) {
      setActiveTab(key);
    }
  }, [location.hash, activeTab]);

  const closePreview = useCallback(() => setPreviewDoc(null), []);

  useEffect(() => {
    if (!previewDoc) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') closePreview();
    };
    document.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [previewDoc, closePreview]);

  const selectTab = (key) => {
    setActiveTab(key);
    navigate(`#${key}`, { replace: true });
  };

  const handleDownload = (e, doc) => {
    e.stopPropagation();
    if (doc.placeholder || !doc.file) return;
    const link = document.createElement('a');
    link.href = doc.file;
    link.download = doc.fileName;
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleCardClick = (doc) => {
    if (doc.placeholder || !doc.file) return;
    setPreviewDoc(doc);
  };

  const docs = DOCUMENTS[activeTab] || [];
  const isAdvertisementTab = activeTab === 'advertisement';
  const isImagePreview = previewDoc?.type === 'image';

  return (
    <section className="ir-docs section">
      <div className="container">
        <div className="section-header text-center">
          <h2 className="section-title">Investor Relations</h2>
          <p className="section-subtitle">
            Access our agreements, committee resolutions and corporate policies
          </p>
        </div>

        <div className="ir-tabs" role="tablist">
          {TABS.map(tab => (
            <button
              key={tab.key}
              type="button"
              role="tab"
              aria-selected={activeTab === tab.key}
              className={`ir-tab ${activeTab === tab.key ? 'active' : ''}`}
              onClick={() => selectTab(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {isAdvertisementTab ? (
          <div className="ir-ad-gallery">
            {docs.map((doc, idx) => (
              <button
                key={idx}
                type="button"
                className="ir-ad-card"
                onClick={() => handleCardClick(doc)}
                aria-label={`View ${doc.name}`}
              >
                <span className="ir-ad-ribbon">
                  <i className="fas fa-newspaper"></i>
                </span>
                <div className="ir-ad-thumb">
                  <img src={doc.file} alt={doc.name} loading="lazy" />
                  <span className="ir-ad-thumb-overlay">
                    <i className="fas fa-search-plus"></i>
                    <span>View Advertisement</span>
                  </span>
                </div>
                <div className="ir-ad-meta">
                  <h4>{doc.name}</h4>
                  <span className="ir-ad-issuer">
                    <i className="fas fa-check-circle"></i> Click to view full image
                  </span>
                </div>
              </button>
            ))}
          </div>
        ) : (
          <div className="ir-doc-grid">
            {docs.map((doc, idx) => (
              <div
                key={idx}
                className={`ir-doc-card ${doc.placeholder ? 'is-placeholder' : ''}`}
                onClick={() => handleCardClick(doc)}
                role={doc.placeholder ? undefined : 'button'}
                tabIndex={doc.placeholder ? -1 : 0}
                onKeyDown={(e) => {
                  if (doc.placeholder) return;
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleCardClick(doc);
                  }
                }}
                aria-label={doc.placeholder ? `${doc.name} (coming soon)` : `Preview ${doc.name}`}
              >
                <div className="ir-doc-icon">
                  <i className={`fas ${doc.type === 'image' ? 'fa-image' : 'fa-file-pdf'}`}></i>
                </div>
                <div className="ir-doc-body">
                  <h4 className="ir-doc-name">{doc.name}</h4>
                  <span className="ir-doc-meta">
                    {doc.placeholder
                      ? 'Coming Soon'
                      : doc.type === 'image'
                        ? 'Image · Click to view'
                        : 'PDF Document · Click to view'}
                  </span>
                </div>
                {doc.placeholder ? (
                  <span className="ir-doc-action is-disabled" aria-hidden="true">
                    <i className="fas fa-clock"></i>
                    <span>Coming Soon</span>
                  </span>
                ) : (
                  <button
                    type="button"
                    className="ir-doc-action"
                    onClick={(e) => handleDownload(e, doc)}
                    aria-label={`Download ${doc.name}`}
                  >
                    <i className="fas fa-download"></i>
                    <span>Download</span>
                  </button>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {previewDoc && isImagePreview && (
        <div
          className="ir-ad-lightbox"
          role="dialog"
          aria-modal="true"
          aria-label={`${previewDoc.name} preview`}
          onClick={closePreview}
        >
          <button
            type="button"
            className="ir-ad-lightbox-close"
            onClick={closePreview}
            aria-label="Close preview"
          >
            <i className="fas fa-times"></i>
          </button>
          <div className="ir-ad-lightbox-scroll" onClick={closePreview}>
            <img
              src={previewDoc.file}
              alt={previewDoc.name}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}

      {previewDoc && !isImagePreview && (
        <div
          className="ir-preview-overlay"
          role="dialog"
          aria-modal="true"
          aria-label={`${previewDoc.name} preview`}
          onClick={closePreview}
        >
          <div className="ir-preview-modal" onClick={(e) => e.stopPropagation()}>
            <div className="ir-preview-header">
              <h3 className="ir-preview-title">{previewDoc.name}</h3>
              <div className="ir-preview-actions">
                <button
                  type="button"
                  className="ir-preview-btn"
                  onClick={(e) => handleDownload(e, previewDoc)}
                >
                  <i className="fas fa-download"></i>
                  <span>Download</span>
                </button>
                <button
                  type="button"
                  className="ir-preview-close"
                  onClick={closePreview}
                  aria-label="Close preview"
                >
                  <i className="fas fa-times"></i>
                </button>
              </div>
            </div>
            <div className="ir-preview-body">
              <iframe
                src={previewDoc.file}
                title={previewDoc.name}
                className="ir-preview-frame"
              />
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default InvestorRelationsDocs;
